import * as types from './colorActionTypes';

const initialState = {
  colorData: null,
  colorList: [],
  createColorData: null,
  createColorError: null,
  updateColorData: null,
  updateColorError: null,
  deleteColorData: null,
  deleteColorError: null,
};

export const colorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COLOR_DATA:
      return {
        ...state,
        colorData: action.payload || null,
        colorList: action.payload?.ColorList || [],
      };
    case types.GET_COLOR_ERROR:
      return {
        ...state,
        colorData: null,
        colorList: [],
      };
    case types.CREATE_COLOR_DATA:
      return {
        ...state,
        createColorData: action.payload,
        createColorError: null,
      };
    case types.CREATE_COLOR_ERROR:
      return {
        ...state,
        createColorData: null,
        createColorError: action.payload,
      };
    case types.UPDATE_COLOR_DATA:
      return {
        ...state,
        updateColorData: action.payload,
        updateColorError: null,
      };
    case types.UPDATE_COLOR_ERROR:
      return {
        ...state,
        updateColorData: null,
        updateColorError: action.payload,
      };
    case types.DELETE_COLOR_DATA:
      return {
        ...state,
        deleteColorData: action.payload,
        deleteColorError: null,
      };
    case types.DELETE_COLOR_ERROR:
      return {
        ...state,
        deleteColorData: null,
        deleteColorError: action.payload,
      };
    default:
      return state;
  }
};
